// extracted by mini-css-extract-plugin
export default {"discountBanner":"Ffa","topheader":"Gfa","navleft":"Hfa","navflexelem":"Ifa","navright":"Jfa","fixedtop":"Kfa","abstop":"Lfa","subdesc":"Mfa","smallscreennav":"Nfa","nav_hidden":"Ofa","cancel_link":"Pfa","bottomnavcontainer":"Qfa","fixedbottom":"Rfa","animatedbottom":"Sfa","appear-bottom":"Tfa","delayedbottom":"Ufa","retakebtn":"Vfa","long_banner":"Wfa","nofixed":"Xfa"};
    if(module.hot) {
      // 1721922369196
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  